module.exports = __webpack_public_path__ + "img/Next-steps.0270934a.svg";